import { render, staticRenderFns } from "./EntranceGuardModal.vue?vue&type=template&id=ebaa1c5e&scoped=true&"
import script from "./EntranceGuardModal.vue?vue&type=script&lang=js&"
export * from "./EntranceGuardModal.vue?vue&type=script&lang=js&"
import style0 from "./EntranceGuardModal.vue?vue&type=style&index=0&id=ebaa1c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa1c5e",
  null
  
)

export default component.exports